module.exports = "/_next/static/images/t1-cc06fc70d3cc4a8091a20ca12a0ce2e3.svg";